"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBroadcaster = exports.sortSessionsByStartDate = exports.isSessionBookable = exports.isSessionFinished = exports.isSessionCancelled = exports.isSessionRunning = exports.isSessionStartingSoon = exports.isSessionJoinable = exports.getSessionLink = exports.getEndDate = exports.getStartDate = exports.SESSION_BUFFER_TIME = exports.SESSION_LOBBY_MINUTES = void 0;
const date_fns_1 = require("date-fns");
const models_1 = require("../models");
exports.SESSION_LOBBY_MINUTES = 15;
exports.SESSION_BUFFER_TIME = 5;
const getStartDate = (session) => {
    if ("start" in session) {
        return (0, date_fns_1.parseJSON)(session.start);
    }
    else {
        return new Date(session.startTimestamp);
    }
};
exports.getStartDate = getStartDate;
const getEndDate = (session) => {
    if ("end" in session) {
        return (0, date_fns_1.parseJSON)(session.end);
    }
    else {
        return new Date(session.endTimestamp);
    }
};
exports.getEndDate = getEndDate;
const getSessionLink = (session, user) => {
    if ((0, exports.isSessionFinished)(session)) {
        if (("mp4Url" in session && session.mp4Url) ||
            ("hlsUrl" in session && session.hlsUrl)) {
            return { pathname: `/replay/${session.programId}/${session.id}` };
        }
        return `/program/${session.programId}`;
    }
    else if ((0, exports.isBroadcaster)(session, user)) {
        return `/session/${session.id}/broadcast`;
    }
    else if ((0, exports.isSessionJoinable)(session)) {
        return `/session/${session.id}/live`;
    }
    else {
        return `/program/${session.programId}`;
    }
};
exports.getSessionLink = getSessionLink;
const isSessionJoinable = (session) => {
    if (session.state === models_1.SessionState.Cancelled ||
        session.state === models_1.SessionState.Finished) {
        return false;
    }
    if (session.state === models_1.SessionState.Running) {
        return true;
    }
    const now = new Date();
    const startDate = (0, exports.getStartDate)(session);
    const endDate = (0, exports.getEndDate)(session);
    if (endDate < now) {
        return false;
    }
    const minutes = (0, date_fns_1.differenceInMinutes)(startDate, now);
    return minutes < exports.SESSION_LOBBY_MINUTES;
};
exports.isSessionJoinable = isSessionJoinable;
const isSessionStartingSoon = (session) => {
    const now = new Date();
    const startDate = (0, exports.getStartDate)(session);
    const minutes = (0, date_fns_1.differenceInMinutes)(startDate, now);
    if (startDate < now) {
        return false;
    }
    return minutes <= exports.SESSION_LOBBY_MINUTES;
};
exports.isSessionStartingSoon = isSessionStartingSoon;
const isSessionRunning = (session) => {
    const startDate = (0, exports.getStartDate)(session);
    const endDate = (0, exports.getEndDate)(session);
    return (session.state === models_1.SessionState.Running &&
        (0, date_fns_1.isPast)(startDate) &&
        (0, date_fns_1.isFuture)(endDate));
};
exports.isSessionRunning = isSessionRunning;
const isSessionCancelled = (session) => {
    return session.state === models_1.SessionState.Cancelled;
};
exports.isSessionCancelled = isSessionCancelled;
const isSessionFinished = (session) => {
    return session.state === models_1.SessionState.Finished;
};
exports.isSessionFinished = isSessionFinished;
const isSessionBookable = (session) => {
    if ((0, exports.isSessionCancelled)(session)) {
        return false;
    }
    const startDate = (0, exports.getStartDate)(session);
    const endDate = (0, exports.getEndDate)(session);
    const now = new Date();
    const start = +startDate;
    const end = +endDate;
    const oneWeekFromNow = +(0, date_fns_1.addDays)(now, 7);
    const isStartingThisWeek = end < oneWeekFromNow && start > now.getTime();
    return isStartingThisWeek;
};
exports.isSessionBookable = isSessionBookable;
const sortSessionsByStartDate = (a, b) => {
    const aStart = (0, exports.getStartDate)(a);
    const bStart = (0, exports.getStartDate)(b);
    return aStart.getTime() - bStart.getTime();
};
exports.sortSessionsByStartDate = sortSessionsByStartDate;
const isBroadcaster = (session, user) => {
    var _a;
    const instructorId = ((_a = session["program"]) === null || _a === void 0 ? void 0 : _a.instructorId) || session.instructorId;
    return instructorId === (user === null || user === void 0 ? void 0 : user.id);
};
exports.isBroadcaster = isBroadcaster;
//# sourceMappingURL=session.js.map